export const routesInfo = {
	Acela: { icon: "🚄", link: "https://www.amtrak.com/acela-train" },
	Adirondack: { icon: "⛰️", link: "https://www.amtrak.com/adirondack-train" },
	"Amtrak Cascades": { icon: "🌲", link: "https://www.amtrak.com/cascades-train" },
	"Amtrak Hartford Line": { icon: "🚆", link: "https://www.amtrak.com/amtrak-hartford-line-train" },
	"Auto Train": { icon: "🚗", link: "https://www.amtrak.com/auto-train" },
	"Berkshire Flyer": { icon: "🌳", link: "https://www.amtrak.com/berkshire-flyer-train" },
	"Blue Water": { icon: "💧", link: "https://www.amtrak.com/michigan-services-train" },
	Borealis: { icon: "🌌", link: "https://www.amtrak.com/borealis-train" },
	Brightline: { icon: "✨", link: "https://www.gobrightline.com/onboard-amenities" },
	"California Zephyr": { icon: "🌄", link: "https://www.amtrak.com/california-zephyr-train" },
	"Capitol Corridor": { icon: "🌉", link: "https://www.amtrak.com/capitol-corridor-train" },
	"Capitol Limited": { icon: "🏛️", link: "https://www.amtrak.com/capitol-limited-train" },
	Cardinal: { icon: "🐦", link: "https://www.amtrak.com/cardinal-train" },
	"Carl Sandburg": { icon: "📖", link: "https://www.amtrak.com/illinois-services-train" },
	Carolinian: { icon: "🐿️", link: "https://www.amtrak.com/carolinian-piedmont-train" },
	"City Of New Orleans": { icon: "🎷", link: "https://www.amtrak.com/city-of-new-orleans-train" },
	"Coast Starlight": { icon: "🌊", link: "https://www.amtrak.com/coast-starlight-train" },
	"Connecting Bus": { icon: "🚌", link: "https://www.amtrak.com/thruway-connecting-services-multiply-your-travel-destinations" },
	Crescent: { icon: "🌙", link: "https://www.amtrak.com/crescent-train" },
	Downeaster: { icon: "🍂", link: "https://www.amtrak.com/downeaster-train" },
	"Empire Builder": { icon: "🏔️", link: "https://www.amtrak.com/empire-builder-train" },
	"Empire Service": { icon: "🗽", link: "https://www.amtrak.com/empire-service-train" },
	"Ethan Allen Express": { icon: "🪓", link: "https://www.amtrak.com/ethan-allen-express-train" },
	Floridian: { icon: "🌴", link: "https://www.amtrak.com/floridian-train" },
	"Heartland Flyer": { icon: "🌽", link: "https://www.amtrak.com/heartland-flyer-train" },
	"Hiawatha Service": { icon: "⛴️", link: "https://www.amtrak.com/hiawatha-train" },
	Illini: { icon: "🏫", link: "https://www.amtrak.com/illinois-services-train" },
	"Illinois Zephyr": { icon: "🌾", link: "https://www.amtrak.com/illinois-services-train" },
	"Keystone Service": { icon: "🔑", link: "https://www.amtrak.com/keystone-service-train" },
	"Lake Shore Limited": { icon: "🚢", link: "https://www.amtrak.com/lake-shore-limited-train" },
	"Lincoln Service": {
		icon: "🎩",
		link: "https://www.amtrak.com/lincoln-service-missouri-river-runner-train",
	},
	"Maple Leaf": { icon: "🍁", link: "https://www.amtrak.com/maple-leaf-train" },
	"Mardi Gras Service": { icon: "🎭", link: "https://www.amtrak.com/amtrak-mardi-gras-service-train" },
	"Missouri River Runner": {
		icon: "💦",
		link: "https://www.amtrak.com/lincoln-service-missouri-river-runner-train",
	},
	NA: { icon: "❓", link: "https://www.amtrak.com" },
	"Northeast Regional": { icon: "🌆", link: "https://www.amtrak.com/northeast-regional-train" },
	"Pacific Surfliner": { icon: "🏄‍♂️", link: "https://www.amtrak.com/pacific-surfliner-train" },
	Palmetto: { icon: "🌿", link: "https://www.amtrak.com/silver-service-palmetto-train" },
	Pennsylvanian: { icon: "⚙️", link: "https://www.amtrak.com/pennsylvanian-train" },
	"Pere Marquette": { icon: "⛵", link: "https://www.amtrak.com/michigan-services-train" },
	Piedmont: { icon: "🏞️", link: "https://www.amtrak.com/carolinian-piedmont-train" },
	Saluki: { icon: "🐕", link: "https://www.amtrak.com/illinois-services-train" },
	"Gold Runner": { icon: "🏃", link: "https://www.amtrak.com/gold-runner-train" },
	"Silver Meteor": { icon: "🌠", link: "https://www.amtrak.com/silver-service-palmetto-train" },
	"Silver Meteor/Palmetto": { icon: "🌴", link: "https://www.amtrak.com/silver-service-palmetto-train" },
	"Southwest Chief": { icon: "🌵", link: "https://www.amtrak.com/southwest-chief-train" },
	"Sunset Limited": { icon: "🌇", link: "https://www.amtrak.com/sunset-limited-train" },
	"Texas Eagle": { icon: "🦅", link: "https://www.amtrak.com/texas-eagle-train" },
	"Valley Flyer": { icon: "🍇", link: "https://www.amtrak.com/valley-flyer-train" },
	Vermonter: { icon: "🛷", link: "https://www.amtrak.com/vermonter-train" },
	"Winter Park Express": { icon: "❄️", link: "https://www.amtrak.com/winter-park-express-train" },
	Wolverine: { icon: "🐺", link: "https://www.amtrak.com/michigan-services-train" }
};
